import { render, staticRenderFns } from "./ProductAdvanceTab.vue?vue&type=template&id=499bdf6c&scoped=true"
import script from "./ProductAdvanceTab.vue?vue&type=script&lang=ts"
export * from "./ProductAdvanceTab.vue?vue&type=script&lang=ts"
import style0 from "./ProductAdvanceTab.vue?vue&type=style&index=0&id=499bdf6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499bdf6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499bdf6c')) {
      api.createRecord('499bdf6c', component.options)
    } else {
      api.reload('499bdf6c', component.options)
    }
    module.hot.accept("./ProductAdvanceTab.vue?vue&type=template&id=499bdf6c&scoped=true", function () {
      api.rerender('499bdf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/ProductAdvanceTab.vue"
export default component.exports